const { getElements } = window.BAO.Utils
class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.conversion = this.dataset.conversion
    this.tableHeadingsFormat = this.dataset.headingsFormat
    this.variantsFormat = this.dataset.variantsFormat

    this.garmentTable = this.els?.garment?.element?.querySelector('table')
    this.bodyTable = this.els?.body?.element?.querySelector('table')

    this.isDown = false
    this.startX = 0
    this.scrollLeftVal = 0
    this.tableSlider = null
    this.tableActiveClass = 'prd-SizeGuide_TableWrap-active'

    this.handleInitialConversion()
    this.handleInitialHeadings()
    this.setInitialTab()

    if (this.hasAttribute('data-option')) {
      this.setDefaultColumns()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(el => {
        this.listeners.add(el, 'click', this.handleTrigger)
      })
    }

    this.onCellClick = this.onCellClick.bind(this)

    getElements('td', { context: this.garmentTable }).forEach(el =>
      this.listeners.add(el, 'click', e =>
        this.onCellClick(e, this.garmentTable),
      ),
    )

    getElements('td', { context: this.bodyTable }).forEach(el =>
      this.listeners.add(el, 'click', e => this.onCellClick(e, this.bodyTable)),
    )

    if (this.els?.inches?.exists) {
      this.onInchesClick = this.onInchesClick.bind(this)

      this.els.inches.elements.forEach(el => {
        this.listeners.add(el, 'click', this.onInchesClick)
      })
    }

    if (this.els?.centimetres?.exists) {
      this.onCentimetresClick = this.onCentimetresClick.bind(this)

      this.els.centimetres.elements.forEach(el => {
        this.listeners.add(el, 'click', this.onCentimetresClick)
      })
    }

    if (this.els?.tablewrap?.exists) {
      this.els.tablewrap.elements.forEach(el => {
        this.listeners.add(el, 'mousedown', this.onMouseDown)
        this.listeners.add(el, 'mouseup', this.onMouseUp)
        this.listeners.add(el, 'mouseleave', this.onMouseLeave)
        this.listeners.add(el, 'mousemove', this.onMouseMove)
      })
    }
  }

  setInitialTab () {
    const activeTab = this.querySelector(
      '[data-size-guide-el="trigger"][aria-pressed="true"]',
    )

    if (!activeTab) return

    this.els.text.elements.forEach(el => {
      el.setAttribute('aria-hidden', el.dataset.tab !== activeTab.dataset.tab)
    })

    const activeTabValue = activeTab.dataset.tab

    this.setAttribute('data-tab', activeTabValue)
  }

  handleInitialConversion () {
    const handleConversion = el => {
      if (el.cellIndex === 0 || el.closest('tr').rowIndex === 0) return

      const originalValueKey = 'data-original-value'
      const originalValue =
        el.getAttribute(originalValueKey) ?? el.textContent.trim()

      if (!el.hasAttribute(originalValueKey)) {
        el.setAttribute(originalValueKey, originalValue)
      }

      // Check for a range e.g. 30-32
      if (originalValue.includes('-')) {
        const range = originalValue.split('-')

        const formatNumber = num => {
          const parsed = parseFloat(num)
          return parsed % 1 === 0
            ? parsed.toFixed(0)
            : parsed.toFixed(2).replace(/\.?0+$/, '')
        }
        const min = formatNumber(range[0])
        const max = formatNumber(range[1])

        if (isNaN(min) || isNaN(max)) return

        const minInches = Math.round((min / 2.54) * 10) / 10
        const maxInches = Math.round((max / 2.54) * 10) / 10

        el.setAttribute('data-min-centimetres', min)
        el.setAttribute('data-max-centimetres', max)
        el.setAttribute('data-min-inches', minInches)
        el.setAttribute('data-max-inches', maxInches)

        if (this.conversion === 'centimetres') {
          el.innerHTML = `${min}-${max}`
        } else {
          el.innerHTML = `${minInches}-${maxInches}`
        }

        return
      }

      const centimetres = parseFloat(originalValue)
      if (isNaN(centimetres)) return

      const formattedCentimetres = centimetres.toFixed(2).replace(/\.?0+$/, '')
      const inches = Math.round((formattedCentimetres / 2.54) * 10) / 10

      el.setAttribute('data-centimetres', formattedCentimetres)
      el.setAttribute('data-inches', inches)

      if (this.conversion === 'centimetres') {
        el.innerHTML = formattedCentimetres
      } else {
        el.innerHTML = inches
      }

      if (this.els?.controls?.exists === true) {
        this.els.controls.element.classList.remove(
          'prd-SizeGuide_Controls-hidden',
        )
      }
    }

    getElements('td', { context: this.garmentTable }).forEach(el =>
      handleConversion(el),
    )

    getElements('td', { context: this.bodyTable }).forEach(el =>
      handleConversion(el),
    )
  }

  handleInitialHeadings () {
    const handleHeadings = el => {
      if (el.cellIndex === 0) return

      const value = el.innerHTML

      el.setAttribute('data-value', value)

      if (this.tableHeadingsFormat !== this.variantsFormat) {
        const currentValue = value
        const currentObject = this.conversions[this.tableHeadingsFormat]
        if (!currentObject) return

        const valueIndex = currentObject.findIndex(
          el => String(el) === String(currentValue),
        )

        const newObject = this.conversions[this.variantsFormat]
        if (!newObject) return

        const newValue = newObject[valueIndex]
        if (!newValue) return

        el.setAttribute('data-converted-value', newValue)
      }
    }

    getElements('tr:first-child td', { context: this.garmentTable }).forEach(
      el => handleHeadings(el),
    )

    getElements('tr:first-child td', { context: this.bodyTable }).forEach(el =>
      handleHeadings(el),
    )

    if (
      this.els?.select?.exists &&
      this.tableHeadingsFormat !== this.variantsFormat
    ) {
      this.els.select.elements.forEach(el => {
        el.value = this.variantsFormat
        const event = new Event('change')
        el.dispatchEvent(event)
      })
    }
  }

  async onInchesClick () {
    this.convertToInches()

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'inches',
        },
      }),
    })
  }

  async onCentimetresClick () {
    this.convertToCentimetres()

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'centimetres',
        },
      }),
    })
  }

  convertToInches () {
    if (this.conversion === 'inches') return
    this.conversion = 'inches'

    this.els.inches.elements.forEach(el => {
      el.setAttribute('aria-current', true)
    })

    this.els.centimetres.elements.forEach(el => {
      el.setAttribute('aria-current', false)
    })

    getElements('td', { context: this.garmentTable }).forEach(el => {
      if (
        !el.hasAttribute('data-inches') &&
        !el.hasAttribute('data-min-inches')
      ) {
        return
      }

      if (el.hasAttribute('data-min-inches')) {
        el.innerHTML = `${el.dataset.minInches}-${el.dataset.maxInches}`
        return
      }

      el.innerHTML = el.dataset.inches
    })

    getElements('td', { context: this.bodyTable }).forEach(el => {
      if (
        !el.hasAttribute('data-inches') &&
        !el.hasAttribute('data-min-inches')
      ) {
        return
      }

      if (el.hasAttribute('data-min-inches')) {
        el.innerHTML = `${el.dataset.minInches}-${el.dataset.maxInches}`
        return
      }

      el.innerHTML = el.dataset.inches
    })
  }

  convertToCentimetres () {
    if (this.conversion === 'centimetres') return

    this.conversion = 'centimetres'

    this.els.inches.elements.forEach(el => {
      el.setAttribute('aria-current', false)
    })

    this.els.centimetres.elements.forEach(el => {
      el.setAttribute('aria-current', true)
    })

    getElements('td', { context: this.garmentTable }).forEach(el => {
      if (
        !el.hasAttribute('data-centimetres') &&
        !el.hasAttribute('data-min-centimetres')
      ) {
        return
      }

      if (el.hasAttribute('data-min-centimetres')) {
        el.innerHTML = `${el.dataset.minCentimetres}-${el.dataset.maxCentimetres}`
        return
      }

      el.innerHTML = el.dataset.centimetres
    })

    getElements('td', { context: this.bodyTable }).forEach(el => {
      if (
        !el.hasAttribute('data-centimetres') &&
        !el.hasAttribute('data-min-centimetres')
      ) {
        return
      }

      if (el.hasAttribute('data-min-centimetres')) {
        el.innerHTML = `${el.dataset.minCentimetres}-${el.dataset.maxCentimetres}`
        return
      }

      el.innerHTML = el.dataset.centimetres
    })
  }

  onCellClick (e, table) {
    const cellIndex = e?.currentTarget?.cellIndex

    if (cellIndex === 0 || !table) return

    table.classList.add('prd-SizeGuide_Table-sizeSelected')

    getElements('td', { context: table }).forEach(el =>
      el.classList.toggle(
        'prd-SizeGuide_Table-columnHighlight',
        el.cellIndex === cellIndex,
      ),
    )

    const matchingHeading = getElements('td', { context: table }).filter(
      el => el.closest('tr').rowIndex === 0 && el.cellIndex === cellIndex,
    )

    if (!matchingHeading.length) return

    let variantTitleStripped = matchingHeading[0]?.dataset?.value
      ?.trim()
      .toLowerCase()
    if (this.tableHeadingsFormat !== this.variantsFormat) {
      variantTitleStripped = matchingHeading[0]?.dataset?.convertedValue
        ?.trim()
        .toLowerCase()
    }

    const matchingOption = Array.from(
      document.querySelectorAll('[data-variant-radios-el="option-choice"]'),
    ).find(
      el =>
        el?.dataset.shortValue?.trim()?.toLowerCase() === variantTitleStripped,
    )

    if (matchingOption) {
      matchingOption.click()
    }
  }

  setDefaultColumns () {
    const option = this.dataset.option

    this.findMatchingColumn(option, this.garmentTable)
    this.findMatchingColumn(option, this.bodyTable)
  }

  findMatchingColumn (option, table) {
    const variantTitle = option.trim()
    const variantTitleStripped = variantTitle.toLowerCase()

    if (!table) return

    let cellIndex = getElements('td, th', { context: table }).findIndex(
      el => el?.dataset?.value?.trim().toLowerCase() === variantTitleStripped,
    )
    if (this.tableHeadingsFormat !== this.variantsFormat) {
      cellIndex = getElements('td, th', { context: table }).findIndex(
        el =>
          el?.dataset?.convertedValue?.trim().toLowerCase() ===
          variantTitleStripped,
      )
    }

    if (cellIndex === -1) return

    table.classList.add('prd-SizeGuide_Table-sizeSelected')

    getElements('th, td', { context: table }).forEach(el =>
      el.classList.toggle(
        'prd-SizeGuide_Table-columnHighlight',
        el.cellIndex === cellIndex,
      ),
    )
  }

  handleTrigger (e) {
    const triggerEl = e.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== triggerEl.dataset.tab,
      )
    })

    this.els.trigger.elements.forEach(trigger => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.tab === triggerEl.dataset.tab,
      )
    })

    this.els.text.elements.forEach(el => {
      el.setAttribute('aria-hidden', el.dataset.tab !== triggerEl.dataset.tab)
    })

    this.setAttribute('data-tab', triggerEl.dataset.tab)
  }

  onMouseDown (e) {
    this.slider = e.target.closest('.prd-SizeGuide_TableWrap')
    this.isDown = true
    this.slider.classList.add(this.tableActiveClass)
    this.startX = e.pageX - this.slider.offsetLeft
    this.scrollLeftVal = this.slider.scrollLeft
  }

  onMouseUp (e) {
    this.isDown = false
    this.slider?.classList.remove(this.tableActiveClass)
  }

  onMouseLeave (e) {
    this.isDown = false
    this.slider?.classList.remove(this.tableActiveClass)
  }

  onMouseMove (e) {
    if (!this.isDown) return

    e.preventDefault()

    const x = e.pageX - this.slider.offsetLeft
    const scroll = x - this.startX

    this.slider.scrollLeft = this.scrollLeftVal - scroll
  }

  get storageName () {
    return 'size_guide_conversion'
  }

  get conversions () {
    return {
      UK: ['4', '6', '8', '10', '12', '14', '16'],
      SML: ['S', 'S', 'M', 'M', 'L', 'L', 'XL'],
      IT: ['36', '38', '40', '42', '44', '46', '48'],
      US: ['0', '2', '4', '6', '8', '10', '12'],
      FR: ['32', '34', '36', '38', '40', '42', '44'],
      DE: ['30', '32', '34', '36', '38', '40', '42'],
      JP: ['3', '5', '7', '9', '11', '13', '15'],
      DK: ['30', '32', '34', '36', '38', '40', '42'],
      AU: ['4', '6', '8', '10', '12', '14', '16'],
      KR: ['33', '44', '55', '66', '77', '88', '99'],
    }
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
